import { __spreadArrays } from "tslib";
export var convertToApplicableProduct = function (groups) {
    if (groups.length === 0) {
        return null;
    }
    return {
        attributes: groups.map(function (fg) { return fg.attributes; })
            .reduce(function (attrs1, attrs2) { return __spreadArrays(attrs1 || [], attrs2); }, [])
            .map(function (a) { return a.key + "|" + a.valueKey; }),
        images: groups[0].images || [],
        productId: groups.length === 1 ? groups[0].productId : 0,
        productName: groups.length === 1 ? groups[0].productName : groups[0].familyName,
        sku: groups.length === 1 ? groups[0].sku : '',
        supportPageUrl: groups[0].supportPageUrl,
    };
};
